module.exports = __webpack_public_path__ + "static/media/logo-white.12e4d5be.png";